<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>FIDELITY CARD</h1></div>
            <div class="content content-full">
              <div v-if="userAuthenticated" class="title">
                PREMI E PUNTI ACCUMULATI
              </div>
                <div class="container">
                    <div v-if="initial_loading_promotion" class="text-center py-4">
                        <div class="spinner-border pb-3 my-5" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else-if="promotion">

                        <div v-if="show_locale_warning" class="p-3 pb-0">
                            <p class="red">
                                <span>
                                    {{$t('fidelity_mask_locali_warning').replace("{NOME_LOCALE}", locale.nome_locale)}}
                                </span>
                            </p>
                        </div>

                        <div v-if="userAuthenticated" class="f22 font-weight-bold text-center pt-4">
                            <img v-if="qr_code_image_url"
                                 :src="qr_code_image_url"
                                 alt="Fidelity QR"
                                 width="150"><br>
                            <div class="mt-4">
                                {{$t("fidelity_card_accumulato")}}: {{personal_score}} <span class="red">*</span>
                            </div>
                        </div>

                        <br>
                        <div class="bg-gray mx-auto text-center p-2 mb-3" style="width: 300px;">
                            Promozione in corso<br>
                            <b class="f4">{{promotion.nome}}</b><br>
                            <span class="color">
                                {{$t("valido_dal")}}
                                {{moment(promotion.dal).format('DD/MM/YYYY')}}
                                {{$t("al")}}
                                {{moment(promotion.al).format('DD/MM/YYYY')}}
                            </span>
                        </div>

                        <div class="p-3">
                            <div v-for="(soglia) in thresholds"
                                 :key="'soglia-' + soglia.id"
                                 class="d-flex align-items-center justify-content-left mb-3">
                                <div class="timeline-badge badge-info-fill mr-3"
                                     :class="{'badge-info-outline': personal_score < soglia.soglia}">
                                    {{soglia.soglia}}
                                </div>
                                <h4 class="timeline-title">
                                    <inc-reward-name :reward="soglia" :type="promotion.tipo"/>
                                </h4>
                            </div>

                            <div>
                                <p class="red">
                                    <span v-if="promotion.modalita === 1">
                                        {{$t('fidelity_card_punti_regola_1_1')}}<br/>
                                        {{$t('fidelity_card_punti_regola_1_2')}}<br/>
                                        {{$t('fidelity_card_punti_regola_1_3')}}<br/>
                                        {{$t('fidelity_card_punti_regola_1_4')}}
                                    </span>
                                    <span v-else-if="promotion.modalita === 2">
                                        {{$t('fidelity_card_punti_regola_2_1')}}<br/>
                                        {{$t('fidelity_card_punti_regola_2_2')}}<br/>
                                        {{$t('fidelity_card_punti_regola_2_3')}}<br/>
                                        {{$t('fidelity_card_punti_regola_2_4')}}
                                    </span>
                                </p>
                                <hr>
                                <p v-if="!promotion.f_cumulabile" class="mt-2 mb-0">
                                    {{$t("fidelity_card_promozione_non_cumulabile")}}
                                </p>
                                <p v-if="!promotion.f_azzera_punti">
                                    {{$t("fidelity_card_punti_non_si_azzerano")}}
                                </p>
                                <span v-if="promotion.modalita === 1 && promotion.f_scadenza_premi">
                                    {{$t("fidelity_card_punti_azzerano_1")}}
                                    {{reward_expire_days}}
                                    {{$t("fidelity_card_punti_azzerano_2")}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="text-center p-3 f4" v-else>
                        <i>{{$t("fidelity_card_no_promozione")}}</i>
                    </div>
                </div>
            </div>

            <div v-if="userAuthenticated && promotion" class="mt-3">
                <div class="header-sottotitolo"><h1>{{$t("fidelity_card_premi_accumulati")}}</h1></div>
                <div class="content content-full" style="min-height: 200px;">
                    <div class="container">
                        <div class="row-sezione text-center">
                            <div v-if="personal_rewards.length">
                                <div class="blocchetto"
                                     v-for="(reward, i) in personal_rewards"
                                     :key="'reward-active-' + reward.id"
                                     :class="{'mt-0': !i}">
                                    {{$t("reward")}}:<br>
                                    <b class="f2">
                                        <inc-reward-name :reward="reward" :type="reward.tipo"/>
                                    </b><br>
                                    <span class="color">
                                        {{$t("valido_dal")}}
                                        {{moment(reward.data_inizio).format('DD/MM/YYYY')}}
                                        {{$t("al")}}
                                        {{moment(reward.data_scadenza).format('DD/MM/YYYY')}}
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="text-center mt-2 f4"><i>{{$t("fidelity_card_no_premi")}}</i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="userAuthenticated && promotion" class="mt-3">
                <div class="header-sottotitolo"><h1>{{$t("fidelity_card_premi_utilizzati")}}</h1></div>
                <div class="content content-full" style="min-height: 200px;">
                    <div class="container">
                        <div class="row-sezione text-center">
                            <div v-if="personal_used_rewards.length">
                                <div class="blocchetto"
                                     v-for="(reward, i) in personal_used_rewards"
                                     :key="'reward-used-' + reward.id"
                                     :class="{'mt-0': !i}">
                                    {{$t("reward")}}:<br>
                                    <b class="f2">
                                        <inc-reward-name :reward="reward" :type="reward.tipo"/>
                                    </b><br>
                                    <span class="color" v-if="getUsedRewardOrderText(reward)">
                                        {{getUsedRewardOrderText(reward)}}
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="text-center mt-2 f4"><i>{{$t("fidelity_card_no_premi")}}</i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import {getFidelityCard} from "../../api/restaurant";
import {getFidelityCardQrCode} from "../../api/account";

import IncRewardName from './partials/IncRewardName';

export default {
    name: "Index",
    components: {IncRewardName},
    data() {
        return {
            fidelity_card: null,
            qr_code_base64: null,
            initial_loading_promotion: true,
        };
    },
    created() {
        this.fetch();
    },
    computed: {
        thresholds: function () {
            if (this.promotion && Array.isArray(this.promotion.soglie)) {
                return [...this.promotion.soglie].sort((a, b) => {
                    if (a.soglia < b.soglia) {
                        return -1;
                    } else if (a.soglia > b.soglia) {
                        return 1;
                    }

                    return 0;
                })
            }

            return [];
        },
        promotion: function () {
            if (this.fidelity_card && this.fidelity_card.promozione) {
                return this.fidelity_card.promozione;
            }

            return null;
        },
        personal_score: function () {
            if (!this.fidelity_card || !this.fidelity_card.punteggio_personale) {
                return 0;
            }

            return this.fidelity_card.punteggio_personale;
        },
        personal_rewards: function () {
            return this.fidelity_card && Array.isArray(this.fidelity_card.premi_personali)
                ? this.fidelity_card.premi_personali
                : [];
        },
        personal_used_rewards: function () {
            return this.fidelity_card && Array.isArray(this.fidelity_card.premi_personali_usati)
                ? this.fidelity_card.premi_personali_usati
                : [];
        },
        show_locale_warning: function () {
            return this.promotion && this.locale && !(this.promotion.mask_locali & this.locale.id);
        },
        qr_code_image_url: function () {
            if (!this.qr_code_base64) {
                return null;
            }

            return 'data:image/png;base64,' + this.qr_code_base64;
        },
        reward_expire_days: function () {
            if (!this.promotion || !this.promotion.f_scadenza_premi) {
                return 0;
            }

            return moment(this.promotion.data_scadenza_premi).diff(moment(this.promotion.al), 'days');
        },
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state,
        }),
        ...mapGetters('auth', {
            userAuthenticated: 'authenticated'
        })
    },
    watch: {
        language: function () {
            this.fetch();
        },
        'locale.id': function () {
            this.fetch();
        },
        'user.email': function () {
            this.fetch();
        }
    },
    methods: {
        getUsedRewardOrderText: function (reward) {
            if (!reward || !reward.ordine_premio || !reward.ordine_premio.ordine) {
                return null;
            }

            return this.$t("fidelity_card_usato_ordine") + ' ' +
                reward.ordine_premio.ordine.id + ' ' +
                this.$t("fidelity_card_usato_ordine_del") + ' ' +
                moment(reward.ordine_premio.ordine.data_ora_consegna_ritiro).format('DD/MM/YYYY');
        },
        fetchQrCode: function () {
            return getFidelityCardQrCode(this.language, {
                id_ristorante: this.id_ristorante,
                email: this.user.email,
                api_key: this.user.api_key,
            }).then((response) => {
                this.qr_code_base64 = response && response.qrcode ? response.qrcode : null;
            });
        },
        fetch: function () {
            if (!this.id_ristorante || !this.locale || !this.locale.id) {
                return;
            }

            this.showLoading(true);
            const payload = {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id
            };

            if (this.userAuthenticated) {
                payload.email = this.user.email;
                payload.api_key = this.user.api_key;
            } else {
                this.qr_code_base64 = null;
            }

            const fidelityPromise = getFidelityCard(this.language, payload).then((response) => {
                this.fidelity_card = response;
            });

            const qrCodePromise = this.userAuthenticated ? this.fetchQrCode() : Promise.resolve();

            Promise.all([fidelityPromise, qrCodePromise]).catch((error) => {
                const messages = error && error.messages ? error.messages : ['Connection error'];
                alert(messages.join('\n'));
            }).finally(() => {
                this.initial_loading_promotion = false;
                this.showLoading(false);
            });
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
